var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeals(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 2.30005C1 1.74776 1.44772 1.30005 2 1.30005H20C20.5523 1.30005 21 1.74776 21 2.30005V24.3C21 24.8523 20.5523 25.3 20 25.3H2C1.44772 25.3 1 24.8523 1 24.3V2.30005ZM2 1.80005C1.72386 1.80005 1.5 2.02391 1.5 2.30005V24.3C1.5 24.5762 1.72386 24.8 2 24.8H20C20.2761 24.8 20.5 24.5762 20.5 24.3V2.30005C20.5 2.02391 20.2761 1.80005 20 1.80005H2Z",
    fill: "#2D2943"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 7.30005H11V6.80005H18V7.30005Z",
    fill: "#2D2943"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 11.3H11V10.8H15V11.3Z",
    fill: "#2D2943"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 15.3H11V14.8H18V15.3Z",
    fill: "#2D2943"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 19.3H11V18.8H14V19.3Z",
    fill: "#2D2943"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 8.30005C9 9.40462 8.10457 10.3 7 10.3C5.89543 10.3 5 9.40462 5 8.30005C5 7.19548 5.89543 6.30005 7 6.30005C8.10457 6.30005 9 7.19548 9 8.30005ZM7 9.80005C7.82843 9.80005 8.5 9.12848 8.5 8.30005C8.5 7.47162 7.82843 6.80005 7 6.80005C6.17157 6.80005 5.5 7.47162 5.5 8.30005C5.5 9.12848 6.17157 9.80005 7 9.80005Z",
    fill: "#2D2943"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.8361 11.6163C5.41535 11.2602 6.17639 11.05 7 11.05C7.87093 11.05 8.67068 11.2849 9.25999 11.6778C9.48063 11.8249 9.675 11.9968 9.83179 12.1891C9.9301 12.3097 10.0136 12.4383 10.0796 12.5738C10.1153 12.6472 10.1459 12.7227 10.1709 12.8C10.1978 12.8835 10.2182 12.9691 10.2316 13.0566C10.2437 13.1362 10.25 13.2174 10.25 13.3H9.75C9.75 12.8579 9.48141 12.4264 8.98265 12.0938C8.92059 12.0525 8.85535 12.013 8.78716 11.9755C8.30982 11.713 7.68773 11.55 7 11.55C6.14913 11.55 5.40016 11.7994 4.90068 12.1766C4.52936 12.4571 4.30967 12.7955 4.26055 13.1482C4.25354 13.1986 4.25 13.2492 4.25 13.3H3.75L3.75 13.2985C3.75017 13.1255 3.77787 12.9589 3.8292 12.8C3.95794 12.4017 4.23529 12.0526 4.59932 11.7776C4.6743 11.721 4.75335 11.6672 4.8361 11.6163Z",
    fill: "#2D2943"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 24.3L23 2.30005L23.5 2.30005L23.5 24.3L23 24.3Z",
    fill: "#2D2943"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.75,
    y: 13.3,
    width: 6.5,
    height: 0.5,
    fill: "#2D2943"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeals);
export default __webpack_public_path__ + "static/media/deals.7cc5e8bf.svg";
export { ForwardRef as ReactComponent };